import { Component, Input } from '@angular/core'
import { Location } from '@angular/common'
import { Writer } from '../../types'
import { UiActions } from '../../actions/ui-actions'

@Component({
  selector: 'writer-avatar',
  styles: [`
    :host {
      display: block;
    }
  `],
  template: `
    <div class="avatar-container">
      <span [popover]="blockedOrPreferredTooltip" triggers="mouseenter:mouseleave">
        <div class="avatar-image-wrapper">
          <a *ngIf="!hideImg" class="image-link" (click)="setLastDashboardPath()" [routerLink]="linkToProfile ? ['/dashboard', customerId, 'writer_profile', writer?.slug] : []">
            <img [attr.alt]="writer.shortDisplayName"
              class="gravatar"
              [class.transparent]="transparentAvatar"
              [class.danger-border]="showBorder"
              [attr.src]="writer.avatar"
              width="{{size}}"
              height="{{size}}"
              [style.border-radius]="borderRadius">
            <div *ngIf="showManage" class="hover-text">Manage</div>
           </a>
          <i *ngIf="hideImg" class="fas fa-user text-muted"></i>
        </div>
        <div class="small text-center" [class.d-none]="hideName">{{ writer.shortDisplayName }}</div>
      </span>
    </div>
  `
})
export class WriterAvatar {
  @Input() writer: Writer;
  @Input() customerId: number;
  @Input() hideName: boolean = false;
  @Input() size: number = 50;
  @Input() borderRadius: string = '4px';
  @Input() hideImg: boolean = false;
  @Input() showManage: boolean = false;
  @Input() preferred: boolean = false;
  @Input() blocked: boolean = false;
  @Input() linkToProfile: boolean = true;
  @Input() transparentAvatar: boolean = false;
  @Input() showBorder: boolean = false;
  private location: Location;
  private uiActions: UiActions;

  constructor(location: Location, uiActions: UiActions) {
    this.location = location
    this.uiActions = uiActions
  }

  setLastDashboardPath(): void {
    const path = this.location && this.location.path()

    // You were already on the writer profile page
    // We need to maintain the old last dashboard path so the "Back to dashboard" button works as expected
    if (!path.match('writer_profile')) {
      this.uiActions.setUiState('lastDashboardPath', path)
    }
  }

  get blockedOrPreferredTooltip(): string {

    let message = ''

   if (this.preferred) {
     message = 'You have preferred this writer'
    } else if (this.blocked){
     message = 'You have blocked this writer'
    }

    return message
  }
}
